export const lookerSteps = {

  no_session_id: "sessionId api returns null value",

  multi_account_user: "Multi Account User",
  autoPay_paperLess_enrolled: "AutoPay and Paper Less Billing Enrolled",
  billCycle_pastDue: "Bill cycle and Past Due Date",
  Payment_services: "User Payment Service",
  user_PA_service : "User PA Service",


  //------------------------------------------------------

  Create_account_CTA : "Create account CTA clicked",
  registration_attempted_via_email : "Registration attempted via Email",
  registration_success_via_email : "Registration success via Email",
  registration_failed_via_email : "Registration failed via Email",
  registration_attempted: "Registration attempted",
  registration_failed:"Registration Failed",
  registration_success: "Registration Success",
  sign_in_attempt: "Sign In Attempted from Registration",
  sign_in_attempt: "Sign In Attempted from Account Lock",
  sign_in_attempt: "Sign In Attempted from Passsword reset",

  //-------------------------------------------------
  help_support_search_attempt: "Help and support search Attempted",
  help_support_search_success: "Help and support search success",
  help_support_search_failed: "Help and support search failed",
  login_attempts: "Login Attempted",
  login_success: "Login Success",
  new_login_success: "New Login Success",
  new_login_failed: "New Login Failed",
  digital_id_api_success: "Digital id api success",
  digital_id_api_failed: "Digital id api failed",
  user_tried_login_in_b2c: "User navigated back to AM from B2C",
  user_tried_login_in_b2c_with_error: "User navigated back to AM with error",
  B2C_signin_cta_clicked: "Login attempted thru B2C",
  B2C_signin__success: "B2C validation success",
  B2C_signin_failed: "B2C validation failed",
  B2C_login_success: "Login success thru B2C",
  B2C_login_failed: "Login failed thru B2C",
  B2C_forgot_password_attempted: "B2C Forgot Password attempted",
  B2C_create_account_attempted: "B2C create account attempted",
  B2C_create_account_success: "B2C Create account success",
  B2C_create_account_failed: "B2C Create account failed",
  B2C_url_redirected: "B2C Signin url redirected",
  User_routed_with_confirmation_email: "User routed with confirmation email",
  fetchId_API_success: "FetchId API Success",
  fetchId_API_failed: "FetchId API Failed",
  login_failed: "Login Failed",
  getaccount_by_cusid_API_success: "getUserAccountDetails by CustID API Success",
  getaccount_by_cusid_API_failed: "getUserAccountDetails by CustID API Failed",
  getaccount_by_ban_API_success: "get-account-details by Ban API Success",
  getaccount_by_ban_API_failed: "get-account-details by Ban API Failed",
  username_notfound: "Username or principalName not found",
  login_with_userName:"login sucess with user name",
  login_with_email:"login sucess with email",
  iam_API_failed: "IAM API failed",
  token_unavailable: "get iam token unavailable",
  reschedule_attempt_tracker_step: "Reschedule appointment Initiated from tracker",
  reschedule_initiated: "Reschedule appointment Initiated",
  reschedule_attempt: "Reschedule appointment Attempted",
  reschedule_appointment_missing_arn: "Reschedule appointment ARN Missing",
  submit_reschedule: "Submit Reschedule Appointment Success",
  submit_reschedule_penidng_disconnect: "Submit Reschedule Appointment Success with Pending Disconnect",
  submit_reschedule_penidng_disconnect_failure: "Submit Reschedule Appointment Failure with Pending Disconnect",
  submit_reschedule_failure: "Submit Reschedule Appointment Failed",
  cancel_reschedule_appointment: "Reschedule appointment cancelled",
  list_pay_methods: "List of Payment Methods API Success",
  payment_failure: "Payment Failed",
  change_password_attempted: "Change Password attempted",
  change_password_success: 'Change Password success',
  change_password_failed: 'Change Password failed',
  account_info_update: "Account info update",
  update_pay_info: "Update Payment Info",
  update_pay_info_success: "Update Payment Info Success",
  update_pay_info_failed: "Update Payment Info Failed",
  set_pass_attempt: "Set Password Attempted",
  set_pass_success: "Set Password Success",
  set_pass_failed: "Set Password Failed",
  forgot_pass_attempt: "Forgot Password Attempted",
  sent_otp: "Send OTP",
  sent_otp_for_sign_up: "send-otp-sign-up",
  sent_otp_for_captcha: "send-otp-captcha",
  sent_otp_for_forget_pass: "send-otp-forget-password",
  validate_otp: "Validate OTP",
  validate_otp_for_sign_up: "Validate-otp-sign-up",
  validate_otp_for_captcha: "Validate-otp-captcha",
  validate_otp_For_forget_pass: "Validate-otp-forget-password",
  forgot_pass_success: "Forgot Password Success",
  forgot_pass_failed: "Forgot Password Failed",
  account_not_enabled: "Account Not Enabled",
  account_enabled: "Account Enabled",
  add_primary_payment: "Add Primary Payment",
  add_payment_method: "Add Payment method",
  add_payment_method_prepay_zuora: "Prepay zuora add payment method success",
  add_payment_method_prepay_paypal_zuora: "Prepay zuora add paypal payment method success",
  add_payment_method_prepay_paypal_zuora_failed: "Prepay zuora add paypal payment method failed",
  add_payment_method_prepay_paypal_token_issue: "Prepay zuora add paypal payment token issue",
  add_payment_method_prepay_failed_catch_block: "Prepay zuora add paypal payment token failed from catch block",
  deleted_payment_method: "Payment method deleted",
  view_statement: "view-statement-clicked",
  payment_success_via_cash: "payment successfully paid via cash payment",
  view_pdf: "view-pdf-clicked",
  viewBill_attempted: "View Bill from account balance attempted",
  viewBill_success: "View Bill from account balance successs",
  viewBill_failed: "View Bill from account balance failed",
  viewBill_history_attempted: "View Bill from history attempted",
  viewBill_history_success: "View Bill from history successs",
  viewBill_history_failed: "View Bill from history failed",
  message_tech_attempt: "Message to Tech attempted",
  message_tech_success: "Message to Tech success",
  message_tech_failure: "Message to Tech failed",
  message_tech_cancel: "Message to Tech cancelled",
  add_to_calander: "Add to Calendar Clicked",
  upcoming_appointment_failure: "Upcoming Appointment API Failed",
  user_with_upcomming_appointment: "User has Upcoming Appointment",
  user_with_prepaid_fiber_wifi_discount: "User has Prepaid Fiber WiFi Discount",
  user_with_postpaid_fiber_wifi_discount: "User has Postpaid Fiber WiFi Discount",
  user_with_postpaid_fiber_negative_account_discount: "User has Postpaid Fiber WiFi Discount with Negative value",
  user_with_prepaid_fiber_negative_account_discount: "User has Prepaid Fiber WiFi Discount with Negative value",
  user_invoice_not_generated:"User Invoice not generated",
  invalid_upcomming_appointment_dispatch_info: "Invalid upcoming-appointment dispatch-info",
  forgot_username_attempt: "Forgot Username Attempted",
  forgot_username_success: "Forgot Username Success",
  forgot_username_failed: "Forgot Username Failed",
  create_account: "Create Account",
  create_acc_set_pass: "Create Acc Set Password",
  create_account_succcess: "Create Account Success",
  create_account_failed: "Create Account Failed",
  pause_service_date_selected: "pause_service_date_selected",
  pause_service_date_defaulted: "pause_service_date_defaulted",
  resume_service_date_selected: "resume_service_date_selected",
  pause_service_cancel_clicked: "pause_service_cancel_clicked",
  pause_service_cancel_success: "pauseservice cancel success",
  pause_service_cancel_failure: "pauseservice cancel failure",
  pause_service_goBack_clicked: "pause_service_goBack_clicked",
  pause_service_attempted: "pause_service_attempted",
  pause_service_success: "pause_service_success",
  pause_service_failure: "pause_service_failure",
  pause_service_clicked: "pause_service_clicked",
  pause_service_update_clicked: "pause_service_update_clicked",
  pause_service_date_defaulted: "pause_service_date_defaulted",
  resume_service_date_selected: "resume_service_date_selected",
  userNotFountWith_cust_ID_Not_Found: "User not found in C360 with customer ID",
  cust_ID_Not_Found: "CustomerID not found",
  subscription_acm_success: "Subscription-acm success",
  subscription_acm_failed: "Subscription-acm Failed",
  upcoming_payment_success: "upcoming paymnet detail success",
  upcoming_payment_failed: "upcoming paymnet detail Failed",
  upcoming_payment_API_Response: "upcoming payment - nextPayment or dueDate is empty",
  invalid_upcoming_payment_due_date: "Invalid upcoming paymnet due date",
  subscription_plan_success: "Subscription-plan success",
  subscription_plan_failed: "Subscription-plan Failed",
  nutritionLabel_clicked: "nutrition label clicked",
  nutritionLabel_success: "nutrition label success",
  nutritionLabel_failed: "nutrition label failed",
  change_plan_attempted: "Change Plan Attempted",
  change_plan_falied: "Change Plan Failed",
  change_plan_success: "Change Plan Success",
  change_plan_fiber: "Change Plan Fiber Attempted",
  change_plan_voice_add: "Change Plan Add Voice Attempted",
  change_plan_voice_cancel: "Change Plan cancel Voice Attempted",
  change_plan_fiber_success: "Change Plan Fiber Success",
  change_plan_voice_add_success: "Change Plan Add Voice Success",
  change_plan_voice_cancel_success: "Change Plan cancel Voice Success",
  pay_now_attempted: "Pay Now Attempted",
  suspended_user_pay_in_cash_cta_attempted: "Suspended-pay in cash attempted-home-banner",
  jeopardy_user_pay_in_cash_cta_attempted: "Jeopardy-pay in cash attempted-home-banner",
  suspended_user_pay_in_cash_notification_attempted: "Suspended-pay in cash attempted-home-notification",
  jeopardy_user_pay_in_cash_notification_attempted: "Jeopardy-pay in cash attempted-home-notification",
  jeopardy_payincash_mybills_attempted: "Jeopardy-pay in cash attempted-mybills-banner",
  suspended_payincash_mybills_attempted : "Suspended-pay in cash attempted-mybills-banner",
  pay_now_jeopardy_attempted: "Pay Now Jeopardy Attempted",
  pay_now_jeopardy_payincash_attempted: "Jeopardy-pay in cash attempted-mybills-notification",
  pay_now_suspended_payincash_attempted : "Suspended-pay in cash attempted-mybills-notification",
  pay_incash_attempted:"Pay in cash attempted from my bills",
  pay_now_success: "Pay Now Success",
  dsl_full_terms: "dslbanner fullterms CTA clicked",
  cc_banner: "Ccbanner updateNow CTA clicked",
  referal_banner:"Referalbanner detail terms CTA clicked",
  future_pause_cta: "Future pause banner modify pause CTA clicked",
  current_pause_cta: "Current pause banner modify pause CTA clicked",
  download_app_banner : "Download mobileapp banner download now CTA clicked",
  pay_now_failed: "Pay Now Failed",
  pay_now_CTA: "Pay now CTA Clicked",
  find_payment_location: "Find a location cta attempted",
  sign_in_attempt: "Sign In Attempted",
  sign_up_attempt: "Sign Up Attempted",
  sign_up_success: "Sign Up Success",
  sign_up_failed: "Sign Up Failed",
  sign_up_getAzInfo_success: "Sign Up flow getAZ API success",
  sign_up_getAzInfo_failed: "Sign Up flow getAZ API failed",
  CTL_User_With_State: "CTL loggedIn user state: <VALUE>",
  BRIM_With_None_CTL:"BRIM account none ctl siteID",
  Initial_login_CTL_Welcome: "Initial CTL login Welcome Banner",
  validateUserDueToReCaptcha: "Validate user due to re-captcha",
  uni_login_address_attempt: "unilogin_attempt_address",
  uni_login_phoneNumber_attempt: "unilogin_attempt_phone",
  uni_login_address_success: "unilogin_success_address",
  uni_login_phoneNumber_success: "unilogin_success_phone",
  network_settings_page_accessed: "Network Settings Page Accessed",
  network_wifi_name_update_success: "Network WiFi Name Update Success",
  network_wifi_name_update_failed: "Network WiFi Name Update Failed",
  network_wifi_password_update_success: "Network WiFi Password Update Success",
  network_wifi_password_update_failed: "Network WiFi Password Update Failed",
  network_modem_restart_success: "Network Modem Restart Success",
  network_modem_restart_failed: "Network Modem Restart Failed",
  network_modem_offline:"Modem is offline",
  network_wifi_password_off_success: "Network WiFi Password turn off Success",
  network_wifi_password_off_failed: "Network WiFi Password turn off Failed",
  network_wifi_name_update_attempted: "network wifi name change attempted",
  network_wifi_name_update_canceled: "network wifi name change canceled",
  network_wifi_password_update_attempted: "network wifi password change attempted",
  network_wifi_password_update_canceled: "network wifi password change canceled",
  network_wifi_password_off_attempted: "network wifi password turn off attempted",
  network_wifi_password_off_canceled: "network wifi password turn off canceled",
  network_wifi_password_on_attempted: "network wifi password turn on attempted",
  account_unlocked: "Account Unlocked Success",
  account_locked: "Account Locked Success",
  account_switched_success: "User switched to other account success",
  multi_account_login: "Multi accounts user has logged in",
  Add_account_attempted: "Add account attempted",
  Add_acc_submit_ban_zip:"Billing account number and zip code submitted to add account",
  forget_acc_num_attempted: "forget account number attempted",
  forget_acc_num_email_success: "Forget account number email success",
  forget_acc_num_email_fail: "Forget account number email failed",
  forget_acc_num_email_API_fail: "Forget account number ge by email API failed",
  forget_acc_num_email_ban_not_found: "Forget account number check with email BAN not found",
  forget_acc_num_try_again_attempt: "Forget account number Try Again attempted",
  add_acc_ban_zip_found_success: "Add account using ban and zip details found successfully",
  add_acc_found_fail: "Add account could not be found",
  add_acc_ban_zip_found_fail: "Add account details could not be found using ban and zip",
  add_acc_OTP_success_with_email:
    "Add account OTP request sent successfully with email",
  add_acc_OTP_success_with_phone:
    "Add account OTP request sent successfully with phone",
  add_acc_OTP_resend_success:"Add account OTP resend successfully",  
  add_acc_OTP_resend_fail:"Add account resend OTP fail",
  add_acc_validated_OTP_attempted:"Add account OTP Verification code attempted",
  add_acc_validated_OTP_success:"Add account OTP Verification code Success",
  cancle_cta_add_acc_comm_not_avaliabe_page: "Cancel clicked on add account communication method not available",
  try_again_add_acc_comm_not_avaliabe_page:"Try again attempted on communication method not available",
  cancle_cta_add_acc_OTP_verification: "Cancel clicked on add account OTP verification page",
  validated_OTP_fail: "Invalid OTP entered",
  validated_OTP_success: "OTP validated successfully",
  registered_account_popup_Success: "Already registered Account popup Success",
  try_again_attempt_registered_Acc_popup:
    "Try Again attempted on registered Account popup",
  registered_account_popup_Cancle: "Cancle on registered Account popup",
  cancle_cta_add_acc_comm_avaliabe_page:"Canceled on communication method",
  add_acc_comm_not_avaliable:"Add account Communication method not available",
  add_acc_success: "Add Account successfully",
  add_acc_fail: "Add Account fail",
  add_acc_validated_OTP_fail: "Add account Invalid OTP entered",
  navigate_to_home: "Add Account success page navigate to dashboard successfully",
  cancle_cta_add_acc: "Cancel clicked on add account",
  cancle_cta_forget_acc_popup: "Cancel clicked on add account forget account popup",
  autoPay_enroll_cancle: "cancle clicked on enroll autoPay",
  autoPay_enroll_sucess: "Autopay enrolled successfully",
  autoPay_enroll_fail: "AutoPay enroll fail",
  paperless_billing_accept: "Paperless billing accepted",
  paperless_billing_decline:"Paperless billing declined",
  AP_remove_sucess: "Autopay removed successfully",
  AP_remove_goback_cta: "Remove autopay goback button clicked",
  AP_remove_confirm_cta: "Remove autopay Initiated",
  AP_remove_failed: "Autopay remove failed",
  AP_add_bank: "Autopay add a bank method link clicked",
  AP_add_CD_card: "Autopay add credit/debit card method link clicked",

  AP_add_PM_CD_card_cancel_cta: "Autopay add credit/debit card method cancel button clicked",
  AP_add_PM_CD_card_continue_cta: "Autopay add credit/debit card method continue button clicked",

  AP_add_PM_CD_card_sucess: "Autopay credit/debit card payment method add successfully",
  AP_add_PM_CD_card_failed: "Autopay add credit/debit card payment method failed",

  AP_edit_PM_CD_card_cancel_cta: "Autopay edit credit/debit card method cancel button clicked",
  AP_edit_PM_CD_card_continue_cta: "Autopay edit credit/debit card method continue button clicked",
  AP_edit_PM_CD_card_failed: "Autopay update credit/debit card payment method failed",
  AP_edit_PM_CD_card_sucess: "Autopay credit/debit card payment method updated successfully",

  AP_add_PM_bank_cancel_cta: "Autopay add bank method cancel button clicked",
  AP_add_PM_bank_continue_cta: "Autopay add bank method continue button clicked",
  AP_add_PM_bank_sucess: "Autopay bank payment method added successfully",
  AP_add_PM_bank_failed: "Autopay add bank payment method failed",

  AP_edit_PM_bank_sucess: "Autopay bank payment method updated successfully",
  AP_edit_PM_bank_failed: "Autopay update bank payment method failed",
  AP_edit_PM_bank_cancel_cta: "Autopay edit bank method cancel button clicked",
  AP_edit_PM_bank_continue_cta: "Autopay edit bank method continue button clicked",


  update_autoPay_back: "Back clicked on manage autoPay",
  
  update_PPM_confirm_back: "Back clicked on confirm primary payment method popup",
  update_PPM_confirm_continue: "Autopay change primary payment method Initiated",
  update_PPM_sucess: "Autopay primary payment method changed successfully",
  update_PPM_fail: "Autopay change primary payment method failed",
  change_PPM_cta: "Autopay change primary payment method clicked",


  CVV_validatin_fail:"CVV validation failed",
  CVV_cancle: "Cancle clicked on CVV popup",
  disable_AutoPay_cancel: "Autopay disable popup cancel button clicked",
  disable_AutoPay_sucess: "Autopay disabled successfully",
  disable_AutoPay_fail: "AutoPay disable failed",
  deleted_payment_method_cancel: "AutoPay cancle clicked on delete payment method popup",
  deleted_payment_method_sucess: "AutoPay payment method deleted successfully",
  deleted_payment_method_fail: "Autopay delete payment method failed",

  android_store_link: "Android Google Play Link Clicked",
  ios_store_link: "Apple Store Link Clicked",
  payment_successful: "step2 of 2, submit payment processed successfuly",
  payment_failed: "step2 of 2, submit payment failed",
  referalClicked: "Referral link clicked",
  register_acc_email_success:"Account register notification email sent successfully",
  referNeighborClicked : "Referral a neighbor link clicked",
  
  
  agree_and_continue: "Step 1 of 2, agree and continue button is clicked",
  /** QBP steps */
  qbp_stepped_in: "qbp stepped in",
  qbp_back_step1: "qbp step-1 Back link clicked",
  qbp_cancel_step1: "qbp step-1 Cancel button clicked",
  qbp_select_bank_continue_step2: "qbp Bank selected & continue step2",
  qbp_select_credit_continue_step2: "qbp Credit selected & continue step2",

  qbp_new_bank_cta: "qbp New bank form link clicked",
  qbp_edit_bank_cta: "qbp Edit bank link clicked",
  qbp_delete_bank_cta: "qbp Delete bank button clicked",
  
  qbp_new_cc_cta: "qbp New credit form link clicked",
  qbp_edit_cc_cta: "qbp Edit credit link clicked",
  qbp_delete_cc_cta: "qbp Delete credit button clicked",

  qbp_cancel_form: 'qbp Cancel form',

  qbp_add_bank_payment_method_attempted: 'qbp add bank payment method attempted',
  qbp_add_credit_payment_method_attempted: 'qbp add credit payment method attempted',
  qbp_add_bank_method_successs: 'qbp Bank method add Sucess',
  qbp_add_bank_method_failed: 'qbp Bank method add Failed',
  qbp_add_credit_method_successs: 'qbp Credit method add Sucess',
  qbp_add_credit_method_failed: 'qbp Credit method add Failed',

  qbp_update_bank_method: 'qbp Update a bank method',
  qbp_update_credit_method: 'qbp Update a credit method',
  
  qbp_update_bank_method_attempted: 'qbp update bank payment method attempted',
  qbp_update_credit_method_attempted: 'qbp update credit payment method attempted',
  qbp_update_bank_method_success: 'qbp Update a bank method Sucess',
  qbp_update_bank_method_failed: 'qbp Update a bank method Failed',
  qbp_update_credit_method_success: 'qbp Update a credit method Sucess',
  qbp_update_credit_method_failed: 'qbp Update a credit method Failed',

  qbp_cvv_validation_success: 'qbp cvv validation success',
  qbp_cvv_validation_failed: 'qbp cvv validation failed',
  qbp_back_step2: "qbp Step-2 Back link clicked",
  qbp_cancel_step2: "qbp step-2 Cancel button clicked",
  qbp_attempted: 'qbp payment attempted',
  qbp_success: 'Quick Bill payment completed successfully',
  // qbp_success: 'qbp payment submit success',
  qbp_failed: 'qbp payment submit failed',
  qbp_close_confirm_cta: 'qbp/unauthentic Close confirm modal',

  unauthqbp_signin_cta: 'unauthqbp AM Siginin button clicked',
  unauthqbp_stepped_in: 'unauthqbp stepped in to step-1',
  unauthqbp_back_step1: "unauthqbp step-1 Back link clicked",
  unauthqbp_cancel_step1: "unauthqbp step-1 Cancel button clicked",
  unauthqbp_actNotFound : "unauthqbp Account not found",

  unauthqbp_add_bank_continue_step2: "unauthqbp step-1 Add bank and continue",
  unauthqbp_add_cc_continue_step2: "unauthqbp step-1 Add credit and continue",
  unauthqbp_add_bank_method_attempted: 'unauthqbp bank method add attempted',
  unauthqbp_add_bank_method_success: 'unauthqbp bank method add success',
  unauthqbp_add_bank_method_failed: 'unauthqbp Bank method add Failed',
  unauthqbp_add_credit_method_attempted: 'unauthqbp Credit method add attempted',
  unauthqbp_add_credit_method_successs: 'unauthqbp Credit method add Sucess',
  unauthqbp_add_credit_method_failed: 'unauthqbp Credit method add Failed',

  unauthqbp_update_bank_method_attempted: 'unauthqbp Update a bank method attempted',
  unauthqbp_update_bank_method_success: 'unauthqbp Update a bank method Sucess',
  unauthqbp_update_bank_method_failed: 'unauthqbp Update a bank method Failed',
  unauthqbp_update_credit_method_attempted: 'unauthqbp Update a credit method attempted',
  unauthqbp_update_credit_method_success: 'unauthqbp Update a credit method Sucess',
  unauthqbp_update_credit_method_failed: 'unauthqbp Update a credit method Failed',

  unauthqbp_back_step2: "unauthqbp Step-2 Back link clicked",
  unauthqbp_cancel_step2: "unauthqbp step-2 Cancel button clicked",
  unauthqbp_attempted: 'unauthqbp payment attempted',
  unauthqbp_attempted_email: 'unauthqbp payment attempted with email',
  unauthqbp_attempted_phone: 'unauthqbp payment attempted with phone',
  unauthqbp_attempted_ban: 'unauthqbp payment attempted with ban',
  
  unauthqbp_success: 'unauthqbp payment submit success',
  unauthqbp_success_email:"unauthqbp payment submit success with email",
  unauthqbp_success_ban:"unauthqbp payment submit success with ban",
  unauthqbp_success_phone:"unauthqbp payment submit success with phone",

  unauthqbp_failed_email:"unauthqbp payment submit failed with email",
  unauthqbp_failed_ban:"unauthqbp payment submit failed with ban",
  unauthqbp_failed_phone:"unauthqbp payment submit failed with phone",

  unauthqbp_failed: 'unauthqbp payment submit failed',
  
  unauthqbp_bank_method_selected: 'unauthqbp bank method selected',
  update_qbp_bank_method: 'Update qbp bank method',
  unauthqbp_credit_method_selected: 'unauthqbp credit method selected',
  update_qbp_credit_method: 'Update QBP credit method',

  unauthqbp_LP_links_clicked: "unauthqbp LP links clicked",

  unauthqbp_LP_account_disconnected : "unauthqbp LP account disconnected",
  unauthqbp_LP_prepay_account:"unauthqbp LP prepay account",
  unauthqbp_LP_enterprise_account:"unauthqbp LP enterprise account",
  unauthqbp_DisconnctedUser_loggedin : "unauthqbp Disconnected User loggedin successfully",
  qbp_DisconnctedUser_loggedin : "qbp Disconnected User loggedin successfully",
  unauthqbp_LP_bill_pending : "unauthqbp LP bill pending",
  Pa_ineligible_landing_already_in_pa_modal:"PA ineligible due to existing payment arrangment",
  Pa_ineligible_invoice_pending:"Invoice creation is pending",
  Pa_ineligible_landing_payment_issue_with_pa_modal: "PA ineligible due to payment issues",
  Pa_ineligible_landing_prepay_account_modal:"PA ineligible due to account type being a prepay account",
  Pa_ineligible_landing_enterprise_account_modal: "PA ineligible due to account type being a enterprise",
  Pa_ineligible_landing_wholesale_account_modal: "PA ineligible due to account type being a wholesale",
  Pa_ineligible_landing_INACTIVE_account_modal: "PA ineligible due to the user being inactive",
  Pa_back_step1: "PA step-1 Back link clicked",
  Pa_stepped_step1: "PA step-1 stepped in",
  Pa_continue_step1: "PA step-1 continue cta clicked to step2",
  pa_autopay_remove_confiramtion: "PA step-1 autopay remove modal continue CTA clicked to step2",
  pa_postpaid_fiber_autopay_remove_confiramtion: "PA step-1 postpaid fiber autopay remove modal continue CTA clicked to step2",
  pa_postpaid_fiber_autopay_remove_cancel: "PA step-1 postpaid fiber autopay remove modal cancel CTA clicked",
  Pa_cancel_step1: "PA step-1 cancel cta clicked to landing page",
  pa_payment_option_select_setp1: "PA step-1 selected payment option",
  Pa_back_step2: "PA step-2 Back link clicked",
  Pa_stepped_step2: "PA step-2 stepped in",
  Pa_stepped_step3: "PA step-3 stepped in",
  Pa_term_and_condition_step2:"PA step-2 T&C checked",
  Pa_cancel_step2: "PA step-2 cancel cta clicked to landing page",
  Pa_agree_and_continue_step2: "PA step-2 agree and continue clicked to step3",
  Pa_add_card_payment_method_success:"PA step-2 card payment method is successfully added",
  Pa_add_card_payment_method_failure: "PA step-2 card payment method adding failed",
  Pa_edit_card_payment_method_success:"PA step-2 card payment method is successfully edited",
  Pa_edit_card_payment_method_failure: "PA step-2 card payment method editing failed",
  Pa_add_bank_payment_method_failure:"PA step-2 bank payment method adding failed",
  Pa_add_bank_payment_method_success:"PA step-2 bank payment method is successfuly added",
  Pa_edit_bank_payment_method_failure:"PA step-2 bank payment method editing failed",
  Pa_edit_bank_payment_method_success:"PA step-2 bank payment method is successfuly edited",
  Pa_past_upcoming_due_date: "PA step-2 upcoming due date is past date",
  Pa_cancel_form:"PA step-2 cancel form clicked",
  Pa_cvv_validation_success: "PA step-2 cvv validation is successful",
  Pa_cvv_validation_failure: "PA step-2 cvv validation is failed",
  Pa_unAuth_ActNotFound: "PA Account not found",
  Pa_quick_bill_on_payment_Arrangment: "PA step-3 QBP on PA success",
  Pa_quick_bill_on_payment_Arrangment_failur: "PA step-3 QBP on PA failed",
  Pa_submit_payment_arrangment: "Payment Arrangement created successfully",
  Pa_submit_payment_arrangment_failed: "PA step-3 submission failed",
  Pa_submit_payment_arrangment_attempt: "PA step-3 submission Attempted",
  Pa_cancel_step3: "PA step-3 cancel cta clicked to landing page",
  Pa_back_step3: "PA step-3 Back link clicked",
  Pa_landing_page_links_clicked:"PA landing page links clicked",
  Pa_otp_validation_success: "PA otp validation success",
  Pa_otp_validation_failure: "PA otp validation failed",
  Pa_otp_validation_email: "PA otp validation via email",
  Pa_otp_validation_phone: "PA otp validation via phone",
  unauthqbp_otp_validation_phone:"unauthqbp otp validation via phone",
  unauthqbp_otp_validation_email:"unauthqbp otp validation via email",
  Pa_fetch_plan_failure:"PA fetch plan failed",
  unauth_otp_validation_success: "unauthqbp otp validation success",
  unauth_otp_validation_failure: "unauthqbp otp validation failed",
  payment_history_api_data_incorrect: "payment history api data incorrect",
  pa_date_incorrect: "pa date incorrect",
  add_AP_pay_method_bank: "The user has selected bank payment method for the autopay",
  add_AP_pay_method_CC : "The user has selected credit/debit card payment method for the autopay",
  AP_delete_PM_bank_cta: "Autopay delete bank method button clicked",
  AP_delete_PM_CD_card_cta: "Autopay delete credit/debit card method button clicked",
  AP_delete_PM_bank_cancel_cta: "Autopay delete payment method cancel button clicked",
  AP_delete_PM_confirm_cta: "Autopay delete payment method confirm button clicked",
  AP_edit_PM_bank_cta: "Autopay edit bank method button clicked",
  AP_edit_PM_CD_card_cta: "Autopay edit credit/debit card method button clicked",
  AP_enroll_cta: "Add Autopay Initiated",
  AP_enroll_failed_popup_cta: "Autopay enroll failed popup Re-enter information button clicked",
  AP_remove_cta: "Remove autopay button clicked",
  AP_remove_PPM_cta: "Autopay delete primary payment method button clicked",
  AP_remove_PPM_cancel_cta: "Autopay delete primary payment method cancel button clicked", 
  AP_remove_PPM_confirm_cta: "Autopay delete primary payment method Initiated",
  AP_remove_PPM_CVV_cancel_cta: "Autopay selected primary payment method CVV popup cancel button clicked", 
  AP_remove_PPM_CVV_confirm_cta: "Autopay selected primary payment method CVV popup confirm button clicked",
  AP_remove_PPM_sucess: "Autopay primary payment method deleted successfully",
  AP_remove_PPM_failed: "Autopay delete primary payment method failed",
  AP_disable_cta: "Autopay disable button clicked",
  AP_disable_confirm_cta: "Autopay disable Initiated",
  Pre_cvv_confirm_cta: "Prepay CVV validation Initiated",
  Pre_cvv_confirm_fail:"Prepay CVV validation failed",
  Pre_cvv_confirm_sucess:"Prepay CVV validation failed success",
  AP_cvv_confirm_cta:"Postpay CVV validation Initiated",
  AP_cvv_confirm_fail:"Postpay CVV validation failed",
  AP_cvv_confirm_sucess:"Postpay CVV validation success",
  Pre_change_PPM_onitiated: "Prepay change primary payment method Initiated",
  Pre_change_PPM_Success: "Prepay primary payment method changed successfully",
  Pre_change_PPM_Failed: "Prepay change primary payment method failed",
  pre_edit_popup_CD_PM_cta :"Prepay edit payment method open popup cta clicked",
  pre_edit_popup_CD_PM_cancle_cta :"Cancle Cta clicked from Prepay edit payment popup",
  pre_update_CD_Pay_cta:"Prepay Update credit/debit card payment method Initiated",
  pre_update_CD_Pay_fail :"Prepay update credit/debit card payment method failed",
  pre_update_CD_Pay_sucess :"Prepay credit/debit card payment method updated successfully",
  pre_add_popup_CD_PM_cta :"Prepay add payment method open popup cta clicked",
  pre_add_popup_CD_PM_cancle_cta :"Cancle Cta clicked from Prepay add payment popup",
  pre_add_CD_Pay_cta :"Prepay add credit/debit card payment method Initiated",
  pre_add_CD_Pay_fail :"Prepay add credit/debit card payment method failed",
  pre_add_CD_Pay_sucess :"Prepay credit/debit card payment method added successfully",
  pre_delete_CD_Pay_cta :"Prepay delete payment method Initiated",
  pre_delete_CD_PM_fail :"Prepay delete payment method failed",
  pre_delete_CD_PM_sucess :"Prepay payment method deleted successfully",
  pre_delete_popup_CD_Pay_cta :"Prepay delete payment method open popup cta clicked",
  pre_delete_popup_CD_Pay_cancle_cta :"Cancle Cta clicked from Prepay delete payment popup",
  add_AP_cta_clicked: "Add autopay clicked from autopay status page",
  add_acc_OTP_initiated:"Add account OTP request Initiated",
  userName_update_fail:"Update user name failed",
  userName_update_success:"Update user name success",
  primary_phone_mobile_confirmation:"User opted in to confirm the primary phone is a mobile number",
  secondary_phone_mobile_confirmation:"User opted in to confirm the secondary phone is a mobile number",
  add_acc_getazinfo_success:"Add acc customer details avaliabe from getazinfo response",
  add_acc_getazinfo_fail:"Add acc Customer details not avaliabe blank response from getazinfo",
  add_acc_BAN_notFound:"Add Account BAN not found in customer 360",
  customer_profile_update_attempt:"Update customer profile attempted",
  update_profile_without_serviceid:"Update customer profile attempted without service Id",
  comm_pref_from_accountSetting:"Communication preference updated successfully from account setting",
  customer_profile_update_fail:"Update customer profile failed",
  customer_profile_update_success:"Update customer profile success",
  add_acc_OTP_success:"Add account OTP sent successfully",
  add_acc_OTP_fail:"Add account sent OTP failed",
  postpay_user_login_success:"Postpaid user logged in successfully",
  prepay_user_login_success:"Prepaid user logged in successfully",
  prepay_ctl_paypal_fail:"Prepay ctl add paypal payment failed",
  prepay_ctl_paypal_BA_toakn_fail:"Prepay ctl paypal BA tokan API failed",
  prepay_ctl_paypal_BA_toakn_success:"Prepay ctl paypal BA tokan API success",
  prepay_zora_addpaymnet_fail:"Prepay add payment fail from Zora payment",
  
  prepay_ctl_paypal_add_attempt:"Add paypal for ctl prepay attempted",
  prepay_ctl_paypal_add_fail:"Add paypal for ctl prepay failed",
  prepay_ctl_paypal_add_success:"Add paypal for ctl prepay successfully",
  prepay_ctl_paypal_login_cancel:"Cancle Cta clicked from PayPal login", 

  lp_unauthqbp_user_stepped: "unauthqbp user stepped in LP",
  lp_unauthqbp_migrated_user_stepped: "unauthqbp migrated user stepped in LP",
  lp_unauthqbp_nextbtn_clicked: "unauthqbp user clicked next button in LP",
  lp_pa_user_stepped: "PA user stepped in LP",
  lp_pa_migrated_user_stepped: "PA QBP migrated user stepped in LP",
  lp_pa_nextbtn_clicked: "PA QBP user clicked next button in LP",
  migrated_user_login: "Migrated CTL User",
  brightspeed_user_login: "Brightspeed Fiber User",
  postpaid_ctl_pending_order:"Postpaid CTL user with Pending order",
  CTL_postpaid_autoPay_enrolled : "Postpaid CTL user with Autopay Enrolled",
  qf_user_login: "Quantum Fiber User",
  brightspeed_now_user_login: "Brightspeed Now User",
  glt_user_login: "4GLTE User",
  ctl_user_login: "CTL User",
  dsl_migrator_user_login : "DSL Migrator user",
  unauthOTP_flow_dropped: "page reloaded during unauthentic OTP flow",

  unauthOTP_PA_sendOTP_stepped: "PA send OTP stepped in",
  unauthOTP_PA_resendOTP_opted: "PA Resend OTP opted",
  unauthOTP_PA_sendOTP_submitted: "PA send OTP submitted",
  unauthOTP_PA_validateOTP_stepped: "PA validate OTP stepped in",
  unauthOTP_PA_validateOTP_submitted: "PA validate OTP submitted",
  unauthOTP_PA_no_comm_method: "PA stepped in no communication method page",

  unauthOTP_QBP_sendOTP_stepped: "unauthqbp send OTP stepped in",
  unauthOTP_QBP_resendOTP_opted: "unauthqbp Resend OTP opted",
  unauthOTP_QBP_sendOTP_submitted: "unauthqbp send OTP submitted",
  unauthOTP_QBP_validateOTP_stepped: "unauthqbp validate OTP stepped in",
  unauthOTP_QBP_validateOTP_submitted: "unauthqbp validate OTP submitted",
  unauthOTP_QBP_no_comm_method:"unauthqbp stepped in no communication method page",

  user_with_1Q_offers: "user logged with 1Q offers",
  user_with_retention_offer: "user logged with Retention Offer",
  user_with_price_lock: "user logged with price lock",
  user_with_5G_plan: "user logged in with 5G plan",
  user_clicked_chat_for_200mbps_plan:"user clicked on 200MB-plan chat to upgrade CTA",
  user_clicked_chat_for_500mbps_plan:"user clicked on 500MB-plan chat to upgrade CTA",
  user_clicked_chat_for_1G_plan : "user clicked on 1G-plan chat to upgrade CTA", 
  user_clicked_chat_for_2G_plan : "user clicked on 2G-plan chat to upgrade CTA", 
  user_clicked_chat_for_5G_plan:    "user clicked on 5G-plan chat to upgrade CTA",
  user_clicked_call_support_for_200mbps_plan:"user clicked on 200MB-plan call to customer care  CTA",
  user_clicked_call_support_for_500mbps_plan:"user clicked on 500MB-plan call to customer care  CTA",
  user_clicked_call_support_for_1G_plan: "user clicked on 1G-plan call to customer care  CTA",
  user_clicked_call_support_for_2G_plan: "user clicked on 2G-plan call to customer care  CTA",
  user_clicked_call_support_for_5G_plan: "user clicked on 5G-plan call to customer care  CTA",
  user_with_8G_plan: "user logged in with 8G plan",
  user_clicked_chat_for_8G_plan:    "user clicked on 8G-plan chat to upgrade CTA",
  user_clicked_call_support_for_8G_plan: "user clicked on 8G-plan call to customer care  CTA",
  vas_thts_add_attempted: "Attempted add THTS plandetails",  
  vas_thic_add_attempted: "Attempted add wifi protection plandetails",
  vas_thic_remove_attempted:"Attempted remove wifi protection plandetails",
  vas_thts_remove_attempted:"Attempted remove THTS plandetails",
  vas_thts_add_success: "VAS Add Tech Home Support Success",
  user_with_vas_thts: "user with VAS THTS logged in",
  vas_removal_cart_attempted: "VAS Tech Home Support removal from cart attempted",

  cart_submission_attempted: "Change plan cart submission attempted",
  cart_submission_success: "Change plan cart submission success",
  cart_submission_fail: "Change plan cart submission failed",
  update_cart_submission_success: "Change Plan Update Cart Success",

  submit_order_success_add_THIC:"submit order success add wifi protection",
  submit_order_fail_add_THIC:"submit order fail add wifi protection",
  submit_order_success_remove_THIC:"submit order success remove wifi protection",
  submit_order_fail_remove_THIC:"submit order fail remove wifi protection",
  
  user_with_vas_WIFI: "user with VAS WIFI logged in",
  user_with_vas_THIC: "user with VAS THIC logged in",
  cart_submission_attempted_THIC: "add cart Attempted with wifi protection",
  cart_submission_attempted_THIC_remove: "remove cart Attempted with wifi protection",
  cart_submission_attempted_THTS: "add cart Attempted with THTS",
  cart_submission_attempted_THTS_remove: "remove cart Attempted with THTS",
  cart_submission_submission_fail_THIC: "add cart fail with wifi protection",
  cart_submission_submission_fail_THTS: "add cart fail with THTS",
  cart_submission_submission_success_THIC: "add cart success with wifi protection",
  cart_submission_submission_success_THTS: "add cart success with THTS",
  remove_cart_submission_submission_fail_THIC: "remove cart fail with wifi protection",
  remove_cart_submission_submission_fail_THTS: "remove cart fail with THTS",
  remove_cart_submission_submission_success_THIC: "remove cart success with wifi protection",
  remove_cart_submission_submission_success_THTS: "remove cart success with THTS",

  cancel_voice_attempted: "cancel voice attempted",
  cancel_voice_success: "cancel voice success",

  back_to_myService: "stepped back to My service section",
  internet_plan_changes: "internet plan change attempted",
  voice_plan_added: "Digital Voice Plan attempted",
  no_voice_selected: "No Voice plan attempted",
  make_more_changes: "Make more changes attempted",
  internet_speed_upgrade: "internet plan upgraded to",
  internet_speed_downgrade:"internet plan downgraded to",
  affinity_internet_speed_downgrade:"affinity user with price lock downgraded to",
  non_affinity_internet_speed_downgrade:"user with price lock downgraded to",
   
  submit_order_attempted:"submit order attempted",
  submit_order_attempted_with_remove_thts:"submit order attempted with remove THTS",
  submit_order_attempted_with_add_thts:"submit order attempted with add THTS",
  submit_order_attempted_with_remove_thic:"submit order attempted with remove wifi protection",
  submit_order_attempted_with_add_thic :"submit order attempted with add wifi protection",
  submit_order_success:"submit order success",
  submit_order_failure:"submit order failure",
  submit_order_attempted_tech_install:"submit order attempted with tech installation",
  submit_order_success_tech_install:"submit order success with tech installation",
  submit_order_failure_tech_install:"submit order failure with tech installation",
  submit_order_attempted_self_install:"submit order attempted with self installation",
  submit_order_success_self_install:"submit order success with self installation",
  submit_order_failure_self_install:"submit order failure with self installation", 
  submit_order_success_internet:"order success with internet",
  submit_order_success_internet_with_retentionoffer: "and loses retention offer discount",
  submit_order_internet_from_oldplan_to_newplan:"change order success from",
  submit_order_internet_failure_from_oldplan_to_newplan:"change order failure from",
  submit_order_success_add_voice:"order success with voice plan",
  submit_order_success_thts:"submit order success with THTS",
  submit_order_success_thts_remove:"submit order success with remove THTS",

  submit_order_success_thic:"submit order success with wifi protection",
  
  submit_order_success_cancel_voice:"order success with cancel voice",
  
  submit_order_failure_internet:"order failed with internet change",
  submit_order_failure_add_voice:"order failed with voice plan",
  submit_order_failure_thts:"submit order failed with THTS",
  submit_order_failure_thts_remove:"submit order failed with remove THTS",
  
  submit_order_failure_thic:"submit order failed with wifi protection",
  submit_order_failure_cancel_voice:"order failed with cancel voice",

  vacation_pause_suspendReason: "vacation suspend reason not provided ",
  manage_service_plan_clicked:"Stepped in Manage Service plan",

  address_qualification_siteid_mismatch: "qualification mismatch",
  user_with_virtualMDUFlag : "user logged in with virtual MDU flag ON",
  user_without_virtualMDUFlag : "user logged in with virtual MDU flag OFF",
  find_user_name_failed: "find username Failed",
  find_user_name_attampted: "find username attempted",
  find_user_name_success: "find username success",
  find_user_name_attampted_with:"find username attempted with",
  find_user_name_success_with:"find username Success with",
  find_user_name_failed_with:"find username Failed with",
  find_user_name_no_contactMethod:"find username no contact method found",
  find_user_name_no_contactMethod_return_login:"find username user clicked on return to login",
  find_user_name_no_contactMethod_try_again:"find username user clicked on try again",

  find_user_name_single_method:"find username single contact method found",
  find_user_name_multiple_method:"find username multiple Contact method found",
  find_user_name_confirmation_attampted:"find username send <VALUE> reminder attempted",
  find_user_name_confirmation_failed:"find username send <VALUE> reminder failed",
  find_user_name_confirmation_success:"find username send <VALUE> reminder successful",

  find_user_name_resent_confirmation_attampted:"find username user clicked on resend reminder",
  find_user_name_resent_confirmation_success:"find username resend reminder success",
  find_user_name_resent_confirmation_failed:"find username resend reminder failed",

  find_user_name_single_em_single_ph:"find username with single email and single phone number",
  find_user_name_click_cancel:"find username clicked on cancel",
  find_user_name_click_return:"find username clicked on return to <VALUE>",
  find_user_name_login_success:"find username login success",
  find_user_name_noHashUsername: "user doesn't have hash username",
  fiber_voice_customer: "fiber voice user logged in",
  forgetPass_login_success:"forget password login success",
  register_login_success:"registration login success",
  c3_user_loggedin: "C3 user logged in",
  unable_to_verify:"unable to verify",
  qbp_attempted_with_email:"unauthqbp login attempted with email",
  qbp_attempted_with_ban:"unauthqbp login attempted with ban",
  qbp_attempted_all:"unauthqbp login attempted",
  qbp_attempted_with_phone:"unauthqbp login attempted with phone",
  pa_attempted_with_email:"payment arrangment login attempted with email",
  pa_attempted_all:"payment arrangment login attempted",
  pa_attempted_with_ban:"payment arrangment login attempted with ban",
  pa_attempted_with_phone:"payment arrangment login attempted with phone",


  qbp_success_with_email:"unauthqbp login success with email",
  qbp_success_with_ban:"unauthqbp login success with ban",
  qbp_success_all:"unauthqbp login success",
  qbp_success_with_phone:"unauthqbp login success with phone",
  unauthQBP_login_success_sendEventLog: "UnAuth QBP Logged in success - Landed on step 1",
  unauthPA_login_success_sendEventLog: "UnAuth PA Logged in success - Landed on step 1",

  pa_success_with_email:"payment arrangment login success with email",
  pa_success_all:"payment arrangment login success",
  pa_success_with_ban:"payment arrangment login success with ban",
  pa_success_with_phone:"payment arrangment login success with phone",


  qbp_failed_with_email:"unauthqbp login failed with email",
  qbp_failed_with_ban:"unauthqbp login failed with ban",
  qbp_failed_with_phone:"unauthqbp login failed with phone",

  pa_failed_with_email:"payment arrangment login failed with email",
  pa_failed_with_ban:"payment arrangment login failed with ban",
  pa_failed_with_phone:"payment arrangment login failed with phone",

  Pa_submit_payment_arrangment_failed_em: "PA step-3 submission failed with email ",
  Pa_submit_payment_arrangment_failed_ban: "PA step-3 submission failed with ban",
  Pa_submit_payment_arrangment_failed_ph: "PA step-3 submission failed with phone",

  Pa_submit_payment_arrangment_em:"Payment Arrangement created successfully with email",
  Pa_submit_payment_arrangment_ph:"Payment Arrangement created successfully with phone",
  Pa_submit_payment_arrangment_ban:"Payment Arrangement created successfully with ban",
  
  user_with_suspended: "User logged in with Suspended status",
  user_with_Jeopardy: "User logged in with Jeopardy status",
  user_with_suspended_postpaid_fiber: "PPF user with Non pay suspended",
  user_with_jeopardy_postpaid_fiber: "PPF user with Jeopardy status",
  user_with_inactive_postpaid_fiber: "PPF disconnected user logged in",
  user_with_pending_postpaid_fiber: "PPF user with change pending",
  
  wg_np_stepped_in_acct_mgmt:"WG NP Stepped in Login Page",
  wg_vac_stepped_in_acct_mgmt:"WG VAC Stepped in Login Page",
  walled_garden_nonpay_suspend_logged_success: "WG NP logged in successfully",
  walled_garden_vacation_pause_logged_success: "WG VAC user logged in successfully",
  wg_np_login_failed: "WG NP user Login Failed",
  wg_vac_login_failed: "WG VAC user Login Failed",
  wg_np_forgot_pass_attempt: "WG NP user Forgot Password Attempted",
  wg_vac_forgot_pass_attempt: "WG VAC user Forgot Password Attempted",
  wg_np_forgot_pass_failed: "WG NP user Forgot Password Failed",
  wg_vac_forgot_pass_failed: "WG VAC user Forgot Password Failed",
  wg_np_forgot_username_failed: "WG NP user Forgot Username Failed",
  wg_vac_forgot_username_failed: "WG VAC user Forgot Username Failed",
  wg_np_find_user_name_click_cancel:"WG NP user find username clicked on cancel",
  wg_vac_find_user_name_click_cancel:"WG VAC user find username clicked on cancel",
  wg_np_forget_acc_num_email_fail: "WG NP user Forget account number email failed",
  wg_vac_forget_acc_num_email_fail: "WG VAC user Forget account number email failed",
  wg_np_forget_acc_num_email_API_fail: "WG NP user Forget account number get by email API failed",
  wg_vac_forget_acc_num_email_API_fail: "WG VAC user Forget account number get by email API failed",

  walled_garden_payment_attempt:"WG NP payment attempt",
  walled_garden_nonpay_suspend_clicked_pay_in_cash: "WG NP user clicked pay in cash",
  walled_garden_nonpay_suspend_clicked_find_location: "WG NP user clicked find a location",
  walled_garden_nonpay_suspend_clicked_cancel: "WG NP user clicked cancel",  
  walled_garden_nonpay_suspend_clicked_paynow: "WG NP user clicked paynow",
  walled_garden_payment_success:"WG NP payment success",
  walled_garden_payment_failed:"WG NP payment failed",

  walled_garden_cancel_pause_attempt:"WG cancel pause attempt",
  walled_garden_vacation_pause_clicked_cancel_pause: "WG VAC user clicked cancel pause",
  walled_garden_vacation_pause_clicked_go_back: "WG VAC user clicked go back",
  walled_garden_vacation_pause_clicked_yes: "WG VAC user clicked yes",
  walled_garden_cancel_pause_success:"WG cancel pause success",
  walled_garden_cancel_pause_failed:"WG cancel pause failed",

  otc_enabled: "OTC Enabled",
  otc_disabled: "OTC Disabled",

  billing_system_null : "Billing system is blank",
  customer_with_bsw_Job_status: "customer with bsw Job status",

  /* Outage Banner log */
  open_outage_banner:"user logged in with open outage banner",
  closed_outage_banner:"user logged in with closed outage banner",

  eont_tracker_closed: "EONT tracker closed by user",
  eont_tracker_close_failed: "EONT tracker close failed",
  eont_tracker_closed_after_timer: "EONT tracker closed automatically (72 Hours)",
  eont_router_tracking_number_link: "Track my router link",
  eont_wifiExtender_tracking_number_link: "Track my WiFi Extender link",
  eont_router_tracking_number_button: "Track my router",
  eont_wifiExtender_tracking_number_button: "Track my WiFi Extender",
  eont_set_up_router: "Set up router",
  eont_set_up_wifi_extender: "Set up WiFi Extender",
  eont_router: "EONT router order user logged in",
  eont_wifi_extender: "EONT wifi extender order user logged in",
  eont_value_missing: "EONT <missingField> value is missing in get-service-details API",

  Wifi_Extender_count_Mismatching: "Wifi Extender count Mismatching",
  wifi_discount: "user logged in wifi extender first month free offer",

  //----------------------------------------------------------------------

  paperless_billing_enroll_attempted: "Paperless billing enroll attempted",
  paperless_billing_enroll_success: "Paperless billing enrolled successfully",
  paperless_billing_enroll_failed: "Paperless billing enroll failed",

  paperless_billing_unenroll_attempted: "Paperless billing unenroll attempted",
  paperless_billing_unenroll_success: "Paperless billing unenroll successfully",
  paperless_billing_unenroll_failed: "Paperless billing unenroll failed",

  Autopay_enroll_attempted: "Autopay enroll attempted",
  Autopay_enroll_successfully: "Autopay enroll successfully",
  Autopay_enroll_failed: "Autopay enroll failed",

  Autopay_unenroll_attempted: "Autopay unenroll attempted",
  Autopay_unenroll_successfully: "Autopay unenroll successfully",
  Autopay_unenroll_failed: "Autopay unenroll failed",

  ppf_payment_credit: "PPF user payment Credit",
  ppf_payment_achOrDebit: "PPF user payment ACH / Debit",
  
  ppf_user_logged_in : "PPF user Logged in",  
  account_with_10dollar_discount : "PPF user Logged in with $10 Discount",  
  user_added_discount: "PPF user qualified $10 discount",
  user_removed_discount: "PPF user un-qualified $10 discount",
  user_under_lockdown: "PPF user under lockdown",
  user_eligible_for_discount_under_lockdown: "PPF user having discount eligibility with lockdown in place",
  user_removed_autopay_message : "Autopay removed",
  user_removed_paperless_billing_message : "Paperless billing removed",
  user_added_autopay_message : "Autopay enrolled",
  user_added_paperless_billing_message : "Paperless billing enrolled",
  ppf_discount_eligible_banner : "Autopay with paperless billing discount banner shown",
  ppf_discount_not_eligible_banner : "Enroll for autopay and paperless billing banner shown",
  ppf_autopay_banner : "Enroll for autopay banner shown",
  ppf_paperless_banner : "Enroll for paperless billing banner shown",
  discount_banner_shown: "Discount banner shown to PPF user",
  ppf_change_payment_attempt: "PPF Change Payment Attempted",
  ppf_change_payment_success: "PPF Change Payment Successful",
  ppf_change_payment_fail: "PPF Change Payment Fail",
  ppf_api_discount_available: "PPF Discount provided from API for not eligible user",
  ppf_api_discount_not_available: "PPF Discount not provided from API for eligible user",

  empty_suspend_reason: "get account Details - suspend Reason is empty",

  //--------------PPF logs --------------------------------------------------------
  ppf_bill_pending:"PPF user with Bill pending",
  ppf_pending_installation:"PPF user with Installation pending",
  ppf_only_voice : "PPF user with only voice",
  ppf_specific_voice : "PPF user with <VALUE> voice",
  ppf_only_internet : "PPF user with only internet",
  ppf_both_voice_internet : "PPF user both voice and internet",
  ppf_with_addons: "PPF user with addons",

  //--------------Outage notification logs --------------------------------------------------------
  check_for_outage_click:"Check for outage clicked",
  check_for_outage_logged_success: "Check for outage user logged in successfully",
  check_for_outage_login_failed: "Check for outage user Login Failed",
  check_for_outage_forgot_pass_attempt: "Check for outage user Forgot Password Attempted",
  check_for_outage_forgot_pass_failed: "Check for outage user Forgot Password Failed",
  check_for_outage_forgot_username_failed: "Check for outage user Forgot Username Failed",
  check_for_outage_find_user_name_click_cancel:"Check for outage user find username clicked on cancel",
  check_for_outage_forget_acc_num_email_fail: "Check for outage user Forget account number email failed",
  check_for_outage_forget_acc_num_email_API_fail: "Check for outage user Forget account number get by email API failed",
  nooutage_bs_banner_shown: "No outage banner shown for BS fiber user",
  nooutage_othr_banner_shown: "No outage banner shown for QF/CTL user",
  nooutage_bs_comm_pref_click_banner: "No outage BS fiber user comm pref clicks in banner",
  nooutage_bs_comm_pref_click_notifications: "No outage BS fiber user comm pref clicks in notifications",
  nooutage_wifi_app_click_banner: "No outage BS fiber user clicks wifi app in banner",
  nooutage_wifi_app_click_notifications: "No outage BS fiber user clicks wifi app in notifications",
  nooutage_othr_comm_pref_click_banner: "No outage QF/CTL user comm pref clicks in banner",
  nooutage_othr_comm_pref_click_notifications: "No outage QF/CTL user comm pref clicks in notifications",
  nooutage_restart_click_banner: "No outage QF/CTL user clicks restart router in banner",
  nooutage_restart_click_notifications: "No outage QF/CTL user clicks restart router in notifications",
 
  dsl_plan_only: "DSL Only Customer Logged In",
  pots_plan_only: "POTS Only Customer Logged In",
  dsl_pots_plan: "DSL + POTS Customer Logged In",

  migration_dsl: "Migration Eligible with DSL",
  migration_voice: "Migration Eligible with Voice",
  migration_no_voice: "Migration Eligible with No Voice",

  pots_plan_only_with_voice: "POTS Only Customer Logged In with Voice",
  pots_plan_only_no_voice: "POTS Only Customer Logged In with No Voice",

  dsl_pots_plan_with_voice: "DSL + POTS Customer Logged In with Voice",
  dsl_pots_plan_no_voice: "DSL + POTS Customer Logged In with No Voice",

  //----------------------  Seamless migration --------------------------------------

  // Major
  seamless_migration_eligible: "SM - Eligible user",
  dsl_and_pots_migrator: "SM - DSL & POTS Eligible user",
  dsl_only_eligible_migrator: "SM - DSL Only Eligible user",
  pots_only_eligible_migrator: "SM - POTS Only Eligible user",
  iwp_ineligible_migrator:" SM - IWP InEligible user",
  ineligible_migrator: "SM - POTS InEligible user",
  get_started_dsl_migration_clicked: "SM - Get Started Button Clicked",
  dsl_migration_submit_order_attempted:"SM - Submit order attempted",
  dsl_internet_plan_added_to_cart:"SM - DSL internet plan added to cart",
  dsl_voice_plan_added_to_update_cart:"SM - DSL voice plan added to cart",
  dsl_voice_plan_added_to_create_cart:"SM - DSL voice plan added to create cart",
  addon_tech_installation_added_to_update_cart:"SM - Addon tech installation added to update cart",
  dsl_voice_plan_update_cart_api_failed:"SM - DSL voice plan cart API failed",
  dsl_internet_plan_create_cart_api_failed:"SM - DSL internet plan cart API failed",
  dsl_addons_api_success:"SM - DSL addons API success",
  dsl_addons_api_failed:"SM - DSL addons API failed",
  dsl_addons_api_productDetails_data:"SM - DSL addons API productDetails has data",
  dsl_addons_api_productDetails_no_data:"SM - DSL addons API productDetails has no data",
  addon_tech_installation_update_cart_api_failed:"SM - Addon tech installation cart API failed",
  dsl_voice_plan_added_to_create_cart_api_failed:"SM - DSL voice plan create cart API failed",
  dsl_migration_submit_order_success:"SM - Submit order success",
  dsl_migration_submit_order_failed:"SM - Submit order failed",

  //minor
  migration_pending_banner_shown: "SM - Migration pending banner shown",
  migration_success_banner_shown: "SM - Migration success banner shown",
  

  start_now_banner_button_clicked : "SM - Start Now Banner button clicked",
  start_now_notification_button_clicked : "SM - Start Now Notification button clicked",

  review_your_changes_attempted : "SM - User clicks on Review your changes button",

  review_your_changes_api_triggered : "SM - confirm available slot api triggered",
  review_your_changes_success : "SM - confirm available slot api success",
  review_your_changes_failed : "SM - confirm available slot api failed",

  available_slot_api_triggered: "SM - available slot api triggered",
  available_slot_api_success: "SM - available slot api success",
  available_slot_api_failed : "SM - available slot api failed",

  internet_api_triggered : "SM - Internet api triggered",
  internet_api_success : "SM - Internet api success",
  internet_api_failed : "SM - Internet api failed",

  voice_api_triggered : "SM - voice api triggered",
  voice_api_success : "SM - voice api success",
  voice_api_failed : "SM - voice api failed",

  add_on_api_triggered : "SM - add on api triggered",
  add_on_api_success : "SM - add on api success",
  add_on_api_failed : "SM - add api failed",


  internet_api_productDetails_data : "SM - Internet api productDetails has data",
  internet_api_productDetails_no_data : "SM - Internet api productDetails has no data",

  voice_api_productDetails_data : "SM - voice api product has data",
  voice_api_productDetails_no_data : "SM - voice api product has no data",

  add_on_api_failed_productGroups_data: "SM - add on api productGroups has data",
  add_on_api_failed_productGroups_no_data: "SM - add on api productGroups has no data",

  SM_back_button_clicked_review_page: "SM - Back button clicked on review page",
  SM_back_button_clicked_appointment_page: "SM - Back button clicked on appointment page",

  // GTM events
  sm_get_started: " sm_get_started",
  sm_review_changes: " sm_review_changes",
  change_Order_cofirm_button: "change_Order_confirm_button",

  //Bill history 
  bill_history_view_pdf_attempted: "Bill History - View PDF attempted",
  bill_history_view_pdf_success: "Bill History - View PDF success",
  bill_history_view_pdf_failed: "Bill History - View PDF failed",
  invoice_history_api_triggered: "invoice-history API Triggered",
  invoice_history_api_success: "invoice-history API success",
  invoice_history_api_failed: "invoice-history API failed",


};